import { ConfigFilterItem, ConfigItem } from 'Core/interfaces'

export enum ReportMainSearchFields {
	reportName = 'searchByName'
}

export enum ReportFilterFields {
	dateTo = 'dateTo',
	dateFrom = 'dateFrom',
	status = 'status'
}

export declare namespace Report {
	interface Basic {
		reportLogId: number
		reportName: BasicString
		fileName: BasicString
		user: BasicString
		runDate: BasicString
		status: BasicString
	}

	namespace Search {
		interface Config {
			[ReportMainSearchFields.reportName]: ConfigItem<ReportMainSearchFields>
		}

		interface Result {
			[ReportMainSearchFields.reportName]: ConfigItem<ReportMainSearchFields>
		}
	}

	namespace Filter {
		interface Config {
			[ReportFilterFields.dateFrom]: ConfigFilterItem<string, null>
			[ReportFilterFields.dateTo]: ConfigFilterItem<string, null>
			[ReportFilterFields.status]: ConfigFilterItem<string, string>
		}
	}
}
